/**
 * Home Page JavaScript - Extracted from inline JS for SEO optimization
 * Manages participatory processes rendering and carousel functionality
 */

document.addEventListener("DOMContentLoaded", function () {
  // ==================== RENDER PROCESSES - AUXILIARY FUNCTIONS ====================

  function fetchGraphQLData(url, query) {
    const headers = {
      "Content-Type": "application/json",
      Accept: "application/json",
    };

    const body = JSON.stringify({ query });

    return fetch(url, {
      method: "POST",
      headers: headers,
      body: body,
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(
            `HTTP error! Status: ${response.status} - ${response.statusText}`
          );
        }
        return response.json();
      })
      .catch((error) => {
        throw new Error(`Error in GraphQL query: ${error.message}`);
      });
  }

  function initTabsAndCarousel() {
    document
      .querySelectorAll(".home-carousel-container")
      .forEach((container) => {
        const nextBtn = container.querySelector(".home-carousel-next");
        const prevBtn = container.querySelector(".home-carousel-prev");
        const carousel = container.querySelector(".home-process-cards-list");

        if (nextBtn && carousel) {
          nextBtn.addEventListener("click", () => {
            carousel.scrollLeft += carousel.offsetWidth;
          });
        }

        if (prevBtn && carousel) {
          prevBtn.addEventListener("click", () => {
            carousel.scrollLeft -= carousel.offsetWidth;
          });
        }
      });

    const tabButtons = document.querySelectorAll(".home-process-tabs div");
    const tabContents = document.querySelectorAll(".home-process-tab-content");

    if (tabButtons.length > 0 && tabContents.length > 0) {
      tabButtons.forEach((button) => {
        button.addEventListener("click", () => {
          tabButtons.forEach((btn) => btn.classList.remove("active"));
          button.classList.add("active");
          tabContents.forEach((content) => content.classList.remove("active"));
          const tabId = button.getAttribute("data-tab");
          const targetTabContent = document.getElementById(tabId);
          if (targetTabContent) {
            targetTabContent.classList.add("active");
          }
        });
      });
    }
  }

  // ==================== RENDER FUNCTION - RENDERS PROCESSES AND TABS ====================

  function renderParticipatoryProcessTypes(
    apiData,
    imageSource = "",
    featuredConfig = {}
  ) {
    if (
      !apiData ||
      !apiData.data ||
      ((!apiData.data.participatoryProcessTypes ||
        apiData.data.participatoryProcessTypes.length === 0) &&
        (!apiData.data.assemblies || apiData.data.assemblies.length === 0))
    ) {
      return '<div class="page-process-error"><span>Nenhum processo encontrado.</span></div>';
    }

    // Featured configuration for process types
    const defaultFeaturedConfig = {
      conferencias: { ids: [], slugs: [] },
      consultas: { ids: [], slugs: [] },
      planos: { ids: [], slugs: [] },
      assemblies: { ids: [], slugs: [] },
    };

    // Merge default configuration with provided one
    const mergedFeaturedConfig = {
      conferencias: {
        ...defaultFeaturedConfig.conferencias,
        ...(featuredConfig.conferencias || {}),
      },
      consultas: {
        ...defaultFeaturedConfig.consultas,
        ...(featuredConfig.consultas || {}),
      },
      planos: {
        ...defaultFeaturedConfig.planos,
        ...(featuredConfig.planos || {}),
      },
      assemblies: {
        ...defaultFeaturedConfig.assemblies,
        ...(featuredConfig.assemblies || {}),
      },
    };

    // Helper function to check if a process is featured
    function isProcessFeatured(process, typeKey) {
      const config = mergedFeaturedConfig[typeKey];
      if (!config) return false;
      return (
        config.ids.includes(process.id) || config.slugs.includes(process.slug)
      );
    }

    // Helper function to sort processes putting featured ones first
    function sortProcessesWithFeatured(processes, typeKey) {
      // Separate featured from non-featured
      const featured = [];
      const nonFeatured = [];

      processes.forEach((process) => {
        if (isProcessFeatured(process, typeKey)) {
          featured.push(process);
        } else {
          nonFeatured.push(process);
        }
      });

      // Sort featured processes by the order defined in the priority arrays
      const config = mergedFeaturedConfig[typeKey];
      if (config && featured.length > 0) {
        featured.sort((a, b) => {
          // Get positions in priority arrays (ids first, then slugs)
          let posA = config.ids.indexOf(a.id);
          let posB = config.ids.indexOf(b.id);

          // If not found in ids array, check slugs array (offset by ids length)
          if (posA === -1) {
            const slugPosA = config.slugs.indexOf(a.slug);
            posA = slugPosA === -1 ? Infinity : config.ids.length + slugPosA;
          }
          if (posB === -1) {
            const slugPosB = config.slugs.indexOf(b.slug);
            posB = slugPosB === -1 ? Infinity : config.ids.length + slugPosB;
          }

          // Sort by priority position (lower index = higher priority)
          return posA - posB;
        });
      }

      // Sort non-featured by date (most recent first)
      nonFeatured.sort((a, b) => {
        const dateA = new Date(a.publishedAt || 0);
        const dateB = new Date(b.publishedAt || 0);
        return dateB - dateA; // Descending (most recent first)
      });

      // Combine featured first (now properly ordered) + non-featured by date
      // Limit to 6 items total per tab
      const combined = [...featured, ...nonFeatured];
      return combined.slice(0, 6);
    }

    // Define fixed order of the first 3 tabs
    const orderedTypes = [
      {
        key: "conferencias",
        title: "Conferência",
        patterns: [
          /^conferencia$|^conferência$|^conferencias$|^conferências$/i,
        ],
      },
      {
        key: "consultas",
        title: "Consulta Pública",
        patterns: [/^consulta pública$|^consultas públicas$/i],
      },
      {
        key: "planos",
        title: "Plano Participativo",
        patterns: [
          /^plano$|^planos$|^plano participativo$|^planos participativos$/i,
        ],
      },
    ];

    const now = new Date();
    const assemblies = (apiData.data.assemblies || []).filter((assembly) => {
      return assembly.publishedAt && new Date(assembly.publishedAt) <= now;
    });

    // Create exactly 3 process types in the correct order, always
    const processTypes = [];

    orderedTypes.forEach((orderedType, index) => {
      let foundType = null;
      if (
        apiData.data.participatoryProcessTypes &&
        apiData.data.participatoryProcessTypes.length > 0
      ) {
        foundType = apiData.data.participatoryProcessTypes.find((type) => {
          const typeTitle = type.title.translation.toLowerCase().trim();
          if (/audiência|audiencia/i.test(typeTitle)) return false;
          return orderedType.patterns.some((pattern) =>
            pattern.test(typeTitle)
          );
        });
      }
      if (foundType) {
        processTypes.push(foundType);
      } else {
        processTypes.push({
          id: `mock-${orderedType.key}`,
          title: { translation: orderedType.title },
          processes: [],
        });
      }
    });

    const cleanImageSource = imageSource.replace(/\/$/, "");
    const defaultImage =
      "https://brasilparticipativo.presidencia.gov.br/rails/active_storage/representations/redirect/eyJfcmFpbHMiOnsibWVzc2FnZSI6IkJBaHBBM0lXQVE9PSIsImV4cCI6bnVsbCwicHVyIjoiYmxvYl9pZCJ9fQ==--8bafc7018fb30be9c9347f0bc17a9ca1fe1daa6c/eyJfcmFpbHMiOnsibWVzc2FnZSI6IkJBaDdCem9MWm05eWJXRjBTU0lJY0c1bkJqb0dSVlE2RkhKbGMybDZaVjkwYjE5c2FXMXBkRnNITUdrQzZBTT0iLCJleHAiOm51bGwsInB1ciI6InZhcmlhdGlvbiJ9fQ==--64bc4c4a355cc6a5184f6bcffc380675f1050437/de091323edc331be9ff2d0371d76e62414923bd9.png";

    let tabHeadersHTML = '<div class="home-process-tabs" style="margin: 0;">';
    let tabContentHTML = "";

    const tabsOrder = [
      "Conferências",
      "Consultas Públicas",
      "Planos Participativos",
      "Conselhos, Colegiados e Fóruns",
    ];

    // Render the first 3 tabs (process types)
    processTypes.forEach((type, index) => {
      const tabId = `home-tab-${index}`;
      const isFirstTab = index === 0;
      const activeClass = isFirstTab ? "active" : "";
      const tabName = tabsOrder[index];
      tabHeadersHTML += `<div class="${activeClass}" data-tab="${tabId}">${tabName}</div>`;

      const validProcesses = type.processes.filter((process) => process);
      const typeKey = orderedTypes[index].key;
      const sortedProcesses = sortProcessesWithFeatured(
        validProcesses,
        typeKey
      );

      const cardsHTML =
        sortedProcesses.length > 0
          ? sortedProcesses
              .map((process) => {
                const imageUrl = process.heroImage
                  ? `${cleanImageSource}/${process.heroImage.replace(
                      /^\//,
                      ""
                    )}`
                  : defaultImage;
                const title = process.title.translation;
                const endDate = new Date(process.endDate);
                const formattedEndDate = endDate.toLocaleDateString("pt-BR", {
                  year: "numeric",
                  month: "2-digit",
                  day: "2-digit",
                });
                const publishedDate = new Date(process.publishedAt);
                const formattedPublishedDate = publishedDate.toLocaleDateString(
                  "pt-BR",
                  { year: "numeric", month: "2-digit", day: "2-digit" }
                );
                const isFeatured = isProcessFeatured(process, typeKey);
                const featuredClass = isFeatured
                  ? " home-process-card-featured"
                  : "";

                return `
              <div class="home-process-card${featuredClass}">
                <img src="${imageUrl}" alt="Imagem do processo participativo ${title}">
                <div class="home-process-card-content">
                  <a href="/processes/${process.slug}" title="Acessar o processo ${title}">${title}</a>
                  <div class="home-process-card-footer">
                    <div class="home-process-card-stats">
                      <i class="fa-solid fa-calendar-days" aria-hidden="true"></i>
                      <div class="home-process-date">
                        <div class="home-process-date-title">Início</div>
                        <div class="home-process-date-value">${formattedPublishedDate}</div>
                      </div>
                      <i class="fa-solid fa-arrow-right" aria-hidden="true"></i>
                      <div class="home-process-date">
                        <div class="home-process-date-title">Encerramento</div>
                        <div class="home-process-date-value">${formattedEndDate}</div>
                      </div>
                    </div>
                    <a href="/processes/${process.slug}" class="br-button primary assembly-view-button mt-3 mb-3" title="Visualizar o processo ${title}">Visualizar</a>
                  </div>
                </div>
              </div>
            `;
              })
              .join("\n")
          : '<span class="process-section-error">Nenhum processo encontrado para este tipo.</span>';

      const activeContentClass = isFirstTab ? "active" : "";
      tabContentHTML += `
        <div id="${tabId}" class="home-process-tab-content ${activeContentClass}">
          <div class="home-carousel-container">
            <div class="home-carousel-nav">
              <button class="home-carousel-prev" aria-label="Voltar"><i class="fa-solid fa-chevron-left" aria-hidden="true"></i></button>
              <button class="home-carousel-next" aria-label="Avançar"><i class="fa-solid fa-chevron-right" aria-hidden="true"></i></button>
            </div>
            <div class="home-carousel-wrapper">
              <div class="home-process-cards-list">${cardsHTML}</div>
            </div>
          </div>
          <a href="/processes?filter%5Bwith_area%5D=&filter%5Bwith_date%5D=all&filter%5Bwith_scope%5D=&filter%5Bwith_type%5D=${type.id}" class="br-button primary" style="width: fit-content; align-self: center;" title="Ver mais processos deste tipo">Ver mais</a>
        </div>
      `;
    });

    // Always render the 4th tab (Councils, Collegiates and Forums)
    const assembliesTabId = "home-tab-assemblies";
    tabHeadersHTML += `<div data-tab="${assembliesTabId}">${tabsOrder[3]}</div>`;

    const validAssemblies = assemblies.filter(
      (assembly) => assembly.parent === null
    );
    const sortedAssemblies = sortProcessesWithFeatured(
      validAssemblies,
      "assemblies"
    );

    const assembliesCardsHTML =
      sortedAssemblies.length > 0
        ? sortedAssemblies
            .map((assembly) => {
              const imageUrl = assembly.heroImage
                ? `${cleanImageSource}/${assembly.heroImage.replace(/^\//, "")}`
                : defaultImage;
              const title = assembly.title.translation;
              const isFeatured = isProcessFeatured(assembly, "assemblies");
              const featuredClass = isFeatured
                ? " home-process-card-featured"
                : "";

              return `
            <div class="home-process-card${featuredClass}">
              <img src="${imageUrl}" alt="Imagem do conselho ${title}">
              <div class="home-process-card-content">
                <a href="/assemblies/${assembly.slug}" title="Acessar o conselho ${title}">${title}</a>
                <div class="home-process-card-footer">
                  <a href="/assemblies/${assembly.slug}" class="br-button primary assembly-view-button" title="Visualizar o conselho ${title}">Visualizar</a>
                </div>
              </div>
            </div>
          `;
            })
            .join("\n")
        : '<span class="process-section-error">Nenhum conselho encontrado.</span>';

    tabContentHTML += `
      <div id="${assembliesTabId}" class="home-process-tab-content">
        <div class="home-carousel-container">
          <div class="home-carousel-nav">
            <button class="home-carousel-prev" aria-label="Voltar"><i class="fa-solid fa-chevron-left" aria-hidden="true"></i></button>
            <button class="home-carousel-next" aria-label="Avançar"><i class="fa-solid fa-chevron-right" aria-hidden="true"></i></button>
          </div>
          <div class="home-carousel-wrapper">
            <div class="home-process-cards-list">${assembliesCardsHTML}</div>
          </div>
        </div>
        <a href="/assemblies" class="br-button primary" style="width: fit-content; align-self: center;" title="Ver mais conselhos">Ver mais</a>
      </div>
    `;

    tabHeadersHTML += "</div>";

    return `<div class="home-processes">${tabHeadersHTML}${tabContentHTML}</div>`;
  }

  // ==================== MAIN FUNCTION - MANAGE PARTICIPATORY PROCESSES ====================

  function manageParticipatoryProcesses(
    apiUrl,
    imageSource = "",
    featuredConfig = {}
  ) {
    const container = document.querySelector("#participatory-process-section");
    if (!container) {
      console.error(
        'Element with id "participatory-process-section" not found.'
      );
      return;
    }

    const processesContainer = container.querySelector(".home-processes");
    if (!processesContainer) {
      console.error('Element with class "home-processes" not found.');
      return;
    }

    processesContainer.innerHTML = `
      <div class="page-process-error">
        <span class="process-loading">Carregando...</span>
      </div>
    `;

    const query = `
      query {
        participatoryProcessTypes {
          id
          title {
            translation(locale: "pt-BR")
          }
          processes {
            id
            slug
            publishedAt
            title {
              translation(locale: "pt-BR")
            }
            heroImage
            hashtag
            votes
            comments
            endDate
          }
        }
        assemblies {
          id
          slug
          title {
            translation(locale: "pt-BR")
          }
          heroImage
          hashtag
          publishedAt
          parent {
            id
          }
        }
      }
    `;

    fetchGraphQLData(apiUrl, query)
      .then((apiData) => {
        // Check for GraphQL errors
        if (apiData.errors && !apiData.data) {
          throw new Error(
            `GraphQL Errors: ${apiData.errors.map((e) => e.message).join(", ")}`
          );
        }

        const renderedHTML = renderParticipatoryProcessTypes(
          apiData,
          imageSource,
          featuredConfig
        );
        processesContainer.innerHTML = renderedHTML;
        initTabsAndCarousel();
      })
      .catch((error) => {
        console.error("Error fetching processes:", error.message);
        processesContainer.innerHTML = `
          <div class="page-process-error">
            <span>Erro ao buscar processos: ${error.message}</span>
          </div>
        `;
      });
  }

  // Featured configuration (customize as needed)
  const featuredConfig = {
    conferencias: {
      ids: [], // Add IDs of featured processes
      slugs: ["cndrss3", "conapir", "CNPM5", "conadipi6", "cidades6cnc"], // Add slugs of featured processes
    },
    planos: {
      ids: [],
      slugs: ["pactors25", "planoclima", "BrasilSemFome", "pnedh"],
    },
    consultas: {
      ids: [],
      slugs: ["politicadedados", "andancas"],
    },
    assemblies: {
      ids: [],
      slugs: [],
    },
  };

  // Call main function with featured configuration
  manageParticipatoryProcesses(
    "https://brasilparticipativo.presidencia.gov.br/api", //prod - try also: /api/graphql
    //"http://localhost:3000/api", //dev
    "https://brasilparticipativo.presidencia.gov.br/",
    featuredConfig
  );

  // News management (assuming manageNews is available globally)
  if (typeof manageNews !== "undefined" && manageNews.manageNews) {
    manageNews.manageNews(
      "https://brasilparticipativo.presidencia.gov.br/api", //prod
      26, //prod
      3, //prod
      "Notícias",
      "Mais Notícias",
      true,
      "https://brasilparticipativo.presidencia.gov.br"
    );
  }
});
